import { useNavigate } from '@frontend/weave-router';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const useFaxNotification = () => {
  const { create, remove } = useNotification<'fax-new'>();
  const navigate = useNavigate();
  useCommonActionSubscriptions('fax-new');

  useNotificationActionSubscription('fax-new', 'view', ({ notification }) => {
    navigate({
      to: '/fax/$filter/$faxId',
      params: { filter: 'inbox', faxId: notification.payload.faxId },
      search: { isNotification: true },
    });
    remove(notification.id);
  });

  return {
    create,
    remove,
  };
};
